import React, { useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";
import 'bootstrap/dist/css/bootstrap.min.css';
import './Faq.css'; // Assurez-vous que le fichier CSS est bien importé

const FAQ = () => {
  const faqData = [
    {
      question: "Qu'est-ce qu'une étude de marché ? ",
      answer: "Une étude de marché est une recherche systématique et objective qui collecte, analyse et interprète des informations sur un marché spécifique, incluant les consommateurs, la concurrence, et l'environnement général du marché."
    },
    {
      question: "Pourquoi est-il important de segmenter le marché ? ",
      answer: "La segmentation permet d'identifier des sous-groupes de consommateurs avec des besoins ou des comportements similaires, ce qui aide à cibler plus efficacement le marketing, à adapter les produits et à optimiser les ressources."
    },
    {
      question: "Quels sont les principaux types de recherche de marché ? ",
      answer: "Il existe principalement deux types : la recherche primaire, où les données sont collectées directement par l'entreprise (sondages, entretiens), et la recherche secondaire, qui utilise des données déjà existantes (rapports d'études, statistiques publiques)."
    },
    {
      question: "Qu'est-ce que la science de la population ? ",
      answer: "C'est une discipline qui étudie les populations humaines, leur taille, leur structure, et leur dynamique, en utilisant des méthodes démographiques pour analyser les phénomènes comme la natalité, la mortalité et les migrations."
    },
    {
      question: "Qu'est-ce que l'intégration des systèmes de données ? ",
      answer: "C'est le processus de combinaison de données provenant de différentes sources et systèmes en une vue unifiée et cohérente pour une utilisation simplifiée."
    },
    {
      question: "Pourquoi est-il important de bien intégrer les systèmes de données ? ",
      answer: "Une intégration efficace permet une analyse croisée des données, améliore la prise de décision, réduit la redondance des données, et facilite l'automatisation des processus."
    }
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };

  return (
    <div class="container">
      <div className="faq-container">
      {faqData.map((faq, index) => (
        <div key={index} className="faq-item">
          <div 
            className="faq-question" 
            onClick={() => toggleFAQ(index)}
          >
            <span>{faq.question}</span>
            <span>
              {openIndex === index ? <FaMinus /> : <FaPlus />} {/* Icône dynamique */}
            </span>
          </div>
          {openIndex === index && (
            <div className="faq-answer">
              {faq.answer}
            </div>
          )}
        </div>
      ))}
    </div>
    {/* <div class="row justify-content-center">
        <div class="col-md-8">
            <div class="accordion" id="modernAccordion">
                <div class="accordion-item">
                    <h2 class="accordion-header">
                        <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                Accordion Item #1
                            </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#modernAccordion">
                        <div class="accordion-body">
                            This is the first item's accordion body. It is shown by default, until the collapse plugin
                            adds the appropriate classes that we use to style each element.
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                Accordion Item #2
                            </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#modernAccordion">
                        <div class="accordion-body">
                            This is the second item's accordion body. It is hidden by default, until the collapse plugin
                            adds the appropriate classes that we use to style each element.
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                Accordion Item #3
                            </button>
                    </h2>
                    <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#modernAccordion">
                        <div class="accordion-body">
                            This is the third item's accordion body. It is hidden by default, until the collapse plugin
                            adds the appropriate classes that we use to style each element.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> */}
    </div>
  );
};

export default FAQ;
